import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { SetAuthorisationHeaders } from "components/auth/AuthorisationHeaders";
import { urls } from "configs/serviceConfig";
import { User } from "types/user";

export const userApi = createApi({
  reducerPath: "userApi",

  baseQuery: fetchBaseQuery({
    baseUrl: `${urls.profileService}/profile/`,
    prepareHeaders: SetAuthorisationHeaders,
  }),
  tagTypes: ['User'],
  endpoints: builder => ({

    getUser: builder.query<User, string>({
      query: userId => {
        return `${userId}`;
      },
      providesTags: (result) =>  [{ type: 'User', id: result?.userId }],
    }),

    updateUser: builder.mutation<User, Partial<User> & Pick<User, 'userId'>>({    
      query(data) {
        const { ...body } = data;
        return {
          url: body.userId ?? "",
          method: "PUT",
          body,
        }
      },      
      invalidatesTags: (result) => [{ type: 'User', id:  result?.userId}],
    }),

  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
   useGetUserQuery, 
   useUpdateUserMutation 
  } = userApi;